import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import {
    ContactView,
    OpportunityContactClient,
    OpportunityContactViewPaginatedResultDto,
    SearchAvailableOpportunityContactsParameters,
    SearchContactsForOpportunityParameters
} from './api-proxies';

@Injectable({
    providedIn: 'root'
})
export class OpportunityContactService {
    constructor(private readonly client: OpportunityContactClient) {}

    async search(body: SearchContactsForOpportunityParameters): Promise<OpportunityContactViewPaginatedResultDto> {
        return await lastValueFrom(this.client.opportunityContactSearchForOpportunity(body));
    }

    async searchAvailable(body: SearchAvailableOpportunityContactsParameters): Promise<ContactView[]> {
        return await lastValueFrom(this.client.opportunityContactSearchAvailable(body));
    }

    async delete(id: number): Promise<void> {
        return await lastValueFrom(this.client.opportunityContactDelete(id));
    }

    async opportunityContactUpdateCompany(id: number) {
        return await lastValueFrom(this.client.opportunityContactUpdateContactCompany(id));
    }
}
